var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "dl",
      { staticClass: "formContainer" },
      [
        _vm.isEmailField
          ? [
              _c(
                "field-title",
                {
                  attrs: { "is-required": true, valid: !_vm.$v.email.$invalid },
                },
                [_vm._v("メールアドレス")]
              ),
              _vm._v(" "),
              _c(
                "dd",
                { class: { error: _vm.$v.email.$error } },
                [
                  _vm.$v.email.$error
                    ? [
                        !_vm.$v.email.required
                          ? _c("span", { staticClass: "errNote" }, [
                              _vm._v("メールアドレスを入力してください。"),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$v.email.$invalid
                    ? [
                        !_vm.$v.email.signupEmailRule
                          ? _c("span", { staticClass: "errNote" }, [
                              _vm._v(
                                "メールアドレスの書式が不正です。（先頭は半角英数以外使用できません。使用できる記号は@_/.-です。ただし、ドットが連続するもの、@の直前にドットがあるものなど、RFC非準拠のものは使用できません。）"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$v.email.$model,
                        expression: "$v.email.$model",
                      },
                    ],
                    staticClass: "regular",
                    attrs: { name: "email", type: "email", id: "email" },
                    domProps: { value: _vm.$v.email.$model },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.$v.email, "$model", $event.target.value)
                        },
                        _vm.setUserInfoIdAndEmail,
                      ],
                    },
                  }),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "field-title",
          {
            attrs: {
              "is-required": true,
              valid: !_vm.$v.jleague_id.$invalid,
              "form-name": _vm.formName,
            },
          },
          [_vm._v("ＪリーグID")]
        ),
        _vm._v(" "),
        _c("jleague-id-field", {
          attrs: {
            validate: _vm.$v.jleague_id,
            "is-xhr": _vm.isXhr,
            "is-unique": _vm.isUnique,
            disabled: _vm.isSignup,
            "form-name": _vm.formName,
            "is-duplicate-jleague-id": _vm.isDuplicateJleagueId,
            "editable-jleague-id": _vm.editableJleagueId,
            isEmailToken: _vm.isEmailToken,
            original_jleague_id: _vm.original_jleague_id,
            activateJleagueId: _vm.activateJleagueId,
          },
          on: { "set-user-info-patch": _vm.setUserInfoPatch },
        }),
        _vm._v(" "),
        _vm.isSignup
          ? [
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": true,
                    valid: !_vm.$v.password.$invalid,
                  },
                },
                [_vm._v("パスワード")]
              ),
              _vm._v(" "),
              _c("password-field", {
                attrs: { validate: _vm.$v.password },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "field-title",
          {
            attrs: {
              "is-required": !_vm.isMinimum,
              valid: !_vm.$v.birthday_ymd.$invalid,
            },
          },
          [_vm._v("生年月日")]
        ),
        _vm._v(" "),
        _c("birthday-field", {
          attrs: { validate: _vm.$v.birthday_ymd },
          on: { "set-user-info-patch": _vm.setUserInfoPatch },
        }),
        _vm._v(" "),
        !_vm.isSignup || _vm.isSignupFull
          ? [
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: _vm.validMemberName,
                  },
                },
                [_vm._v("氏名")]
              ),
              _vm._v(" "),
              _c("member-name-field", {
                attrs: {
                  "validate-last-name": _vm.$v.member_last_nm,
                  "validate-first-name": _vm.$v.member_first_nm,
                },
                on: {
                  "set-user-info-patch": _vm.setUserInfoPatch,
                  "last-name-handler": _vm.lastNameHandler,
                  "first-name-handler": _vm.firstNameHandler,
                },
              }),
              _vm._v(" "),
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: _vm.validMemberNameKana,
                  },
                },
                [_vm._v("氏名カナ")]
              ),
              _vm._v(" "),
              _c("member-kana-name-field", {
                attrs: {
                  "validate-last-name": _vm.$v.member_last_nm_kana,
                  "validate-first-name": _vm.$v.member_first_nm_kana,
                },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("dt", [_vm._v("性別")]),
        _vm._v(" "),
        _c("sex-field", {
          attrs: { validate: _vm.$v.sex_kbn },
          on: { "set-user-info-patch": _vm.setUserInfoPatch },
        }),
        _vm._v(" "),
        !_vm.isSignup || _vm.isSignupFull
          ? [
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: !_vm.$v.postcode.$invalid,
                  },
                },
                [_vm._v("郵便番号")]
              ),
              _vm._v(" "),
              _c("postcode-field", {
                attrs: { validate: _vm.$v.postcode },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "field-title",
          {
            attrs: {
              "is-required": !_vm.isMinimum,
              valid: !_vm.$v.prefecture.$invalid,
            },
          },
          [_vm._v("都道府県")]
        ),
        _vm._v(" "),
        _c("prefecture-field", {
          attrs: { validate: _vm.$v.prefecture },
          on: { "set-user-info-patch": _vm.setUserInfoPatch },
        }),
        _vm._v(" "),
        !_vm.isSignup || _vm.isSignupFull
          ? [
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: !_vm.$v.address_city.$invalid,
                  },
                },
                [_vm._v("市区町村")]
              ),
              _vm._v(" "),
              _c("address-city-field", {
                attrs: { validate: _vm.$v.address_city },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
              _vm._v(" "),
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: !_vm.$v.address_street.$invalid,
                  },
                },
                [_vm._v("町域番地")]
              ),
              _vm._v(" "),
              _c("address-street-field", {
                attrs: { validate: _vm.$v.address_street },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
              _vm._v(" "),
              _c("dt", [_vm._v("建物号室")]),
              _vm._v(" "),
              _c("address-building-field", {
                attrs: { validate: _vm.$v.address_building },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
              _vm._v(" "),
              _c(
                "field-title",
                {
                  attrs: {
                    "is-required": _vm.isFull,
                    valid: !_vm.$v.tel_no_fixed.$invalid,
                  },
                },
                [_vm._v("電話番号")]
              ),
              _vm._v(" "),
              _c("phone-number-field", {
                attrs: { validate: _vm.$v.tel_no_fixed },
                on: { "set-user-info-patch": _vm.setUserInfoPatch },
              }),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isDisplayAgreementCheck
          ? [
              _c(
                "field-title",
                { attrs: { "is-required": true, valid: _vm.agreement } },
                [_vm._v("利用規約")]
              ),
              _vm._v(" "),
              _c("agreement-field", {
                attrs: { checked: _vm.agreement },
                on: { "check-agreement": _vm.checkAgreement },
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btnSpace" },
      [
        _vm.isSignup
          ? _c("xhr-button", {
              attrs: {
                invalid: _vm.invalid,
                "is-xhr": _vm.isXhr,
                "is-error": _vm.isError,
                activateJleagueId: _vm.isDuplicateJleagueId
                  ? !_vm.activateJleagueId
                  : false,
                "gtm-event-id": "regist_next_tap",
              },
              on: { "on-click": _vm.next },
            })
          : _c("xhr-button", {
              attrs: {
                invalid: _vm.invalid,
                "is-xhr": _vm.isXhr,
                "is-error": _vm.isError,
                activateJleagueId: !_vm.isUnique
                  ? !_vm.activateJleagueId
                  : false,
              },
              on: { "on-click": _vm.next },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }